// extracted by mini-css-extract-plugin
export var wrapperStyle = "stat-module--wrapperStyle--Ei+1D";